// 商品ページへスライダー送りボタンを追加
window.addEventListener("DOMContentLoaded", () => {
  const mediaList = document.querySelector(".product__media-list");
  if (mediaList) {
    let activeMedia = mediaList.querySelector(".is-active");
    const next = document.querySelector("button[name='next']");
    const prev = document.querySelector("button[name='previous']");
    const thumbnailsList = document.querySelector('[id^="GalleryThumbnails"]');
    const mql = window.matchMedia("(min-width: 750px)");

    function updateActiveMedia() {
      activeMedia = document.querySelector(".product__media-list .is-active");
      if (activeMedia == mediaList.firstElementChild) {
        prev.setAttribute("disabled", "disabled");
      } else {
        prev.removeAttribute("disabled");
      }
      if (activeMedia == mediaList.lastElementChild) {
        next.setAttribute("disabled", "disabled");
      } else {
        next.removeAttribute("disabled");
      }

      // Update thumbnail
      if (thumbnailsList) {
        const activeThumbnail = thumbnailsList.querySelector(
          `[data-target="${activeMedia.dataset.mediaId}"]`
        );
        setActiveThumbnail(activeThumbnail);
      }
    }

    function setActiveThumbnail(thumbnail) {
      if (!thumbnailsList || !thumbnail) return;

      thumbnailsList
        .querySelectorAll("button")
        .forEach((element) => element.removeAttribute("aria-current"));
      thumbnail.querySelector("button").setAttribute("aria-current", true);

      // PC画面の場合のみスクロール処理を行う
      if (mql.matches) {
        if (!isElementInViewport(thumbnail)) {
          const thumbnailsSlider = thumbnailsList.querySelector(".slider");
          if (thumbnailsSlider) {
            thumbnailsSlider.scrollTo({
              left: thumbnail.offsetLeft,
              behavior: "smooth",
            });
          }
        }

        // Force Shopify's slider to update for PC
        if (thumbnailsList.slider) {
          thumbnailsList.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }
    }

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      const containerRect = thumbnailsList.getBoundingClientRect();
      return (
        rect.left >= containerRect.left && rect.right <= containerRect.right
      );
    }

    next.addEventListener("click", () => {
      if (activeMedia.nextElementSibling) {
        activeMedia.classList.remove("is-active");
        activeMedia.nextElementSibling.classList.add("is-active");
        updateActiveMedia();
      }
    });

    prev.addEventListener("click", () => {
      if (activeMedia.previousElementSibling) {
        activeMedia.classList.remove("is-active");
        activeMedia.previousElementSibling.classList.add("is-active");
        updateActiveMedia();
      }
    });

    const thumbnails = document.querySelectorAll(".thumbnail");
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", () => {
        updateActiveMedia();
      });
    });

    // Mutation Observerを使用して動的な変更を監視
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          updateActiveMedia();
        }
      });
    });

    observer.observe(mediaList, {
      attributes: true,
      subtree: true,
      attributeFilter: ["class"],
    });

    // 画面サイズが変更されたときの処理
    mql.addEventListener("change", updateActiveMedia);

    // 初期状態の更新
    updateActiveMedia();
  }
});

//のしの処理
window.addEventListener("DOMContentLoaded", function () {
  const noshiSelect = document.getElementById("noshi");
  if (noshiSelect) {
    const nameField = document.querySelector(".line-item-property__name");
    const nameTextarea = document.getElementById("name");
    const form = document.querySelector("form");

    function toggleNameField() {
      if (noshiSelect.value === "なし") {
        nameField.style.display = "none";
        nameTextarea.value = "";
      } else {
        nameField.style.display = "block";
      }
    }

    toggleNameField();

    noshiSelect.addEventListener("change", toggleNameField);
  }
});
